import { Reveal } from '../primitives'

const SMALL_PHOTOS = [
  { src: '/landing/river-1100.jpg', width: 1100, height: 619, alt: 'Two rigs crossing a rocky river bar in early autumn' },
  { src: '/landing/convoy-1280.jpg', width: 1280, height: 720, alt: 'A convoy on a canyon road, heading for a tunnel in the rock' },
  { src: '/landing/camp-1280.jpg', width: 1280, height: 720, alt: 'Camp kitchen set up between two rigs in a sunlit pine forest' },
  { src: '/landing/tunnel-1920.jpg', width: 1920, height: 1080, alt: 'A convoy with its lights on driving out of a narrow rock tunnel' },
]

export function GallerySection() {
  return (
    <section className="pt-[var(--l-section)]">
      <div className="l-frame">
        <Reveal as="h2" className="l-head">
          Everyone's shots, one gallery.
        </Reveal>
        <Reveal as="p" delay={60} className="l-soft mt-4 max-w-[44ch]">
          Like, comment, and pick the trip cover together.
        </Reveal>

        <Reveal delay={120} className="mt-10 grid gap-2 lg:mt-14 lg:grid-cols-12">
          <img
            src="/landing/lookout-1600.jpg"
            alt="Seven rigs parked below a fire lookout at dusk, with mountain ridges behind"
            width={1600}
            height={1199}
            loading="lazy"
            className="aspect-[4/3] h-full w-full object-cover lg:col-span-7"
          />
          <div className="grid grid-cols-2 gap-2 lg:col-span-5">
            {SMALL_PHOTOS.map((photo) => (
              <img
                key={photo.src}
                src={photo.src}
                alt={photo.alt}
                width={photo.width}
                height={photo.height}
                loading="lazy"
                className="aspect-[4/3] h-full w-full object-cover"
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  )
}
